export default __webpack_public_path__ + "static/media/13.68e2ccb2.png";